/**
 * Palette is where the base colors live
 * Palette color names should be descriptive of the color,
 * i.e. it should have the name of color in it and match closely
 * to the Figma style guide
 */
// Fixme: This as a const object makes more sense, with enums autocompletion is
// broken, Typescript recommemds this as well:
// https://www.typescriptlang.org/docs/handbook/enums.html#objects-vs-enums
export var Palette;
(function (Palette) {
    // Redesign 2022
    // *************
    // Note: Please only add colors by value names, not usage.
    // For example, don't put "warningOrange", put "orange"
    // If you feel you need to include usage to differentiate it from
    // another color, speak to design first and ask what the
    // name of the color should be.
    Palette["orange"] = "#F2A328";
    Palette["green"] = "#48C66B";
    Palette["darkGreen"] = "#00650A";
    //= =================================================
    // Beiges
    //= =================================================
    Palette["beige"] = "#D9C9BB";
    Palette["beige10"] = "#FDF9F5";
    Palette["beige20"] = "#F7F4F1";
    Palette["beige30"] = "#ECE4DD";
    Palette["beige40"] = "#ECE4DD";
    Palette["beige50"] = "#E6DBD2";
    Palette["beige60"] = "#DFD2C6";
    //= =================================================
    // Blues
    //= =================================================
    Palette["blue"] = "#62A0F8";
    Palette["royalBlue"] = "#3957E1";
    Palette["royalBlue80"] = "#2F48BB";
    Palette["royalBlue90"] = "#263A96";
    Palette["darkBlue"] = "#28293C";
    Palette["lightBlue"] = "#62A0F8";
    Palette["primaryBlue"] = "#01314A";
    Palette["blue10"] = "#F5F7FD";
    Palette["blue20"] = "#E0ECFE";
    Palette["blue30"] = "#D4E2FB";
    Palette["blue40"] = "#B0CFFB";
    Palette["blue50"] = "#96C0FA";
    Palette["blue60"] = "#7CB0F9";
    //= =================================================
    // Corals
    //= =================================================
    Palette["coral"] = "#F8D9D7";
    Palette["coral10"] = "#FFEEEC";
    Palette["coral20"] = "#FFE6E4";
    Palette["coral30"] = "#FFD5D3";
    Palette["coral40"] = "#FFC0BC";
    Palette["coral50"] = "#FFACA6";
    Palette["coral60"] = "#FF9790";
    //= =================================================
    // Mints
    //= =================================================
    Palette["mint"] = "#76E4AF";
    Palette["mint10"] = "#EEFCF5";
    Palette["mint20"] = "#E3FAEF";
    Palette["mint25"] = "#ECF3EF";
    Palette["mint30"] = "#C8F4DF";
    Palette["mint40"] = "#BAF1D7";
    Palette["mint50"] = "#A4EDCA";
    Palette["mint60"] = "#8DE8BC";
    Palette["mint80"] = "#54936C";
    //= =================================================
    // Reds
    //= =================================================
    Palette["red"] = "#EA1616";
    Palette["updaterRed"] = "#F94550";
    //= =================================================
    // Grays
    //= =================================================
    Palette["black"] = "#000000";
    Palette["gray10"] = "#1A1A1A";
    Palette["gray20"] = "#333333";
    Palette["gray30"] = "#4D4D4D";
    Palette["gray40"] = "#666666";
    Palette["gray50"] = "#808080";
    Palette["gray60"] = "#999999";
    Palette["gray70"] = "#B2B2B2";
    Palette["gray80"] = "#CCCCCC";
    Palette["gray90"] = "#E5E5E5";
    Palette["gray94"] = "#EFEFEF";
    Palette["gray96"] = "#F5F5F5";
    Palette["gray98"] = "#F1F5F9";
    Palette["white"] = "#FFFFFF";
    Palette["transparent"] = "rgba(0,0,0,0)";
    //= =================================================
    // Sunset Colors - Soon to be deprecated colors for v4
    //= =================================================
    /**
     * @deprecated "hiYellow" will be deprecated in v4 of ui-uds.
     */
    Palette["hiYellow"] = "#F9CB24";
    /**
     * @deprecated "softBlue" will be deprecated in v4 of ui-uds.
     */
    Palette["softBlue"] = "#7DB8E5";
    /**
     * @deprecated "softerBlue" will be deprecated in v4 of ui-uds.
     */
    Palette["softerBlue"] = "#7DB8E54D";
    /**
     * @deprecated "goGreen" will be deprecated in v4 of ui-uds.
     */
    Palette["goGreen"] = "#62CE91";
    /**
     * @deprecated "petalPink" will be deprecated in v4 of ui-uds.
     */
    Palette["petalPink"] = "#F8D9D7";
    /**
     * @deprecated "sunTan" will be deprecated in v4 of ui-uds.
     */
    Palette["sunTan"] = "#ECE2D9";
    /**
     * @deprecated "confirmationGreen" will be deprecated in v4 of ui-uds.
     */
    Palette["confirmationGreen"] = "#43B929";
    /**
     * @deprecated "warningOrange" will be deprecated in v4 of ui-uds.
     */
    Palette["warningOrange"] = "#F2A328";
    /**
     * @deprecated "errorRed" will be deprecated in v4 of ui-uds.
     */
    Palette["errorRed"] = "#ED0037";
    /**
     * @deprecated "linkBlue" will be deprecated in v4 of ui-uds.
     */
    Palette["linkBlue"] = "#0069A0";
    /**
     * @deprecated "hoverBlue" will be deprecated in v4 of ui-uds.
     */
    Palette["hoverBlue"] = "#0083C8";
})(Palette || (Palette = {}));
//# sourceMappingURL=data:application/json;base64,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